import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Carousel3d from 'vue-carousel-3d'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import VabCount from '@/extra/VabCount'
import './permission'
import vab from '@/utils/vab'
import '@/assets/icons' // svg
// Vue.component('vab-count', VabCount)
import VabChart from '@/extra/VabChart'
Vue.component('vab-chart', VabChart)
// 引入动画库
import anime from 'animejs'
Vue.prototype.$animejs = anime
Vue.use(vab)
Vue.use(ElementUI)
Vue.use(Carousel3d)
import './style/indx.scss' // global css
Vue.config.productionTip = false
// 导入echart
import * as echarts from 'echarts' // global filters
Vue.prototype.$echarts = echarts

// 全局边框
import cusBorder from '@/components/cus-border'
Vue.use(cusBorder)
/**
 * @description 正式环境默认使用mock，正式项目记得注释后再打包
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('@/utils/static')
//   mockXHR()
// }

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
